import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SttTable, SttTopControls } from '../../../sporttia/all';
import FormQuestionDialog from '../../../components/dialogs/FormQuestionDialog';
import { PERMISSIONS } from '../../../lib/permissions';

type FormQuestion = {
    id?: string | number;
    name: string;
    typeLang?: string;
    mandatory?: boolean;
};

type QuestionsData = {
    count?: number;
    rows: FormQuestion[];
};

type Event = {
    id: string | number;
    form?: FormQuestion[];
};

type Props = {
    event: Event;
    onChange: (form: FormQuestion[]) => void;
};

export default function EventForm({
    event,
    onChange,
}: Props): React.ReactElement {
    const [questions, setQuestions] = useState<QuestionsData>({ rows: [] });
    const [viewQuestion, setViewQuestion] = useState<FormQuestion | null>(null);

    const { t } = useTranslation();

    // Si cambia el event, recargamos el form (necesario al actualizar)
    useEffect(() => {
        if (event.form) {
            setQuestions({ count: event.form.length, rows: event.form });
        }
    }, [event]);

    return (
        <>
            <SttTopControls
                mb={6}
                mainAction={{
                    type: 'create',
                    permission: PERMISSIONS.EVENT.MODIFY,
                    onClick: () => setViewQuestion({ name: '' }),
                }}
            />
            <SttTable
                data={questions}
                hidePagination
                columns={[
                    {
                        title: t('Question'),
                        align: 'left',
                        type: 'link',
                        field: 'name',
                        onClick: (row: FormQuestion) => setViewQuestion(row),
                    },
                    {
                        title: t('Type'),
                        type: 'text',
                        field: 'typeLang',
                    },
                    {
                        title: t('Mandatory'),
                        type: 'active',
                        value: (row: FormQuestion) => !!row.mandatory,
                    },
                ]}
            />
            <FormQuestionDialog
                parentCategory="events"
                permission={PERMISSIONS.EVENT.MODIFY}
                idParent={event.id as number}
                item={viewQuestion as any}
                onSave={(question: any) => {
                    if (
                        questions.rows.find(
                            (q: any) => q.id === question.id,
                        ) === undefined
                    ) {
                        onChange([...questions.rows, question]);
                    } else {
                        onChange(
                            questions.rows.map((q: any) =>
                                q.id === question.id ? question : q,
                            ),
                        );
                    }
                }}
                onDelete={(question: any) => {
                    onChange(
                        questions.rows.filter((q: any) => q.id !== question.id),
                    );
                }}
                onClose={() => setViewQuestion(null)}
            />
        </>
    );
}
